import _isEqual from 'lodash/isEqual';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _find from 'lodash/find';
import _includes from 'lodash/includes';
import _sortBy from 'lodash/sortBy';

export const getSelectOptions = (options: any, multi = false) => {
	if (!Array.isArray(options)) {
		return [];
	}

	let returnOptions = options;
	if (options.length > 0 && multi) {
		returnOptions = [{ id: 'all', label: 'All' }, ...options];
	}
	return returnOptions;
};

export const dehydrateSelectValue = (value: any, options: any, multi = false) => {
	if (value) {
		const formValue = _map(value, (formVal) => formVal.id);

		if (multi) {
			if (_includes(formValue, 'all')) {
				return _map(options, (option) => option.id);
			}

			return formValue;
		}

		return formValue[0];
	}
	return null;
};

export const hydrateSelectValue = (value: any, options: any, onChange: any, multi = false) => {
	if (value !== undefined && value !== null) {
		const inputValues = multi ? value : [value];

		if (options.length > 0 && multi) {
			const optionsIds = _map(options, (option) => option.id);
			if (_isEqual(_sortBy(optionsIds), _sortBy(inputValues))) {
				return [{ id: 'all', label: 'All' }];
			}
		}

		const hydratedValue = _filter(
			_map(inputValues, (inputValue) => _find(options, (option) => option.id === inputValue)),
			(item) => item !== undefined && item !== null
		);

		if (hydratedValue.length !== inputValues.length) {
			onChange(dehydrateSelectValue(hydratedValue, options, multi));
		}

		return hydratedValue;
	}
	return [];
};
